module.exports = __webpack_public_path__ + "static/media/student-summary-round-next.1c26c3aa.png";